import { AvailabilityResponse, BookingRequest, BookingResponse, ServiceType, ProviderId } from '../types';

const API_BASE = '/api';
const API_KEY = import.meta.env.VITE_API_KEY || '';

function getHeaders(): HeadersInit {
  const headers: HeadersInit = {
    'Content-Type': 'application/json'
  };

  if (API_KEY) {
    headers['Authorization'] = `Bearer ${API_KEY}`;
  }

  return headers;
}

export async function fetchAvailability(
  serviceId: ServiceType,
  providerId: ProviderId,
  tz: string
): Promise<AvailabilityResponse> {
  const params = new URLSearchParams({
    serviceId,
    tz,
    ...(providerId !== 'auto' && { providerId })
  });

  const response = await fetch(`${API_BASE}/availability?${params}`, {
    headers: getHeaders()
  });

  if (!response.ok) {
    const errorBody = (await response.json().catch(() => null)) as { error?: string } | null;
    throw new Error(errorBody?.error || `HTTP ${response.status}`);
  }

  const data = await response.json().catch(() => null);
  if (!data) {
    throw new Error('Failed to parse availability response');
  }

  return data as AvailabilityResponse;
}

export async function createBooking(request: BookingRequest): Promise<BookingResponse> {
  const response = await fetch(`${API_BASE}/book`, {
    method: 'POST',
    headers: getHeaders(),
    body: JSON.stringify(request)
  });

  const body = await response.json().catch(() => null);

  if (!response.ok) {
    const errorMessage = (body as { error?: string } | null)?.error;
    throw new Error(errorMessage || `HTTP ${response.status}`);
  }

  if (!body) {
    throw new Error('Failed to parse booking response');
  }

  return body as BookingResponse;
}
